import { TitleBar } from 'components';
import { TITLE_BAR_HEIGHT_PX } from 'components/navbars/TitleBar.styles';
import { ProtectedRoute } from 'hoc';
import { useMe } from 'hooks/auth';
import { AmbossLayer, useAmboss } from 'widgets/amboss';
import { PatientMismatchBanner } from 'widgets/patientSync';
import { CenteredContent, Main } from './ProtectedLayout.styles';

export default function ProtectedLayout({
  children,
  centered = false,
  fillViewport = false,
  title,
  subtitle,
  hasBackButton = true,
  interactionId,
  showsPatientMismatchBanner = true,
}: {
  children: React.ReactNode;
  centered?: boolean;
  /** Bounds `<main>` to the viewport instead of growing with content, so a screen that manages
   * its own scroll region (rather than relying on the document scrolling) can actually bound it. */
  fillViewport?: boolean;
  title?: string;
  subtitle?: string;
  hasBackButton?: boolean;
  interactionId?: string;
  showsPatientMismatchBanner?: boolean;
}) {
  const { data: user } = useMe();
  const ambossOpen = useAmboss().screen !== 'closed';

  return (
    <ProtectedRoute>
      <TitleBar
        firstName={user?.firstName}
        lastName={user?.lastName}
        title={title}
        subtitle={subtitle}
        hasBackButton={hasBackButton}
        interactionId={interactionId}
        inert={ambossOpen}
      />
      <Main
        $centered={centered}
        $ambossOverlayOpen={ambossOpen}
        $fillViewport={fillViewport}
        tabIndex={-1}
        inert={ambossOpen}
        style={{ paddingTop: TITLE_BAR_HEIGHT_PX }}
      >
        {showsPatientMismatchBanner && <PatientMismatchBanner />}
        {centered ? <CenteredContent>{children}</CenteredContent> : children}
      </Main>
      <AmbossLayer topOffsetPx={TITLE_BAR_HEIGHT_PX} />
    </ProtectedRoute>
  );
}
